<template>
  <div class="flex flex-row">
    <div v-if="!outOfStock" class="mr-4 flex flex-row rounded-full bg-white">
      <button class="px-6 py-3" @click="changeQuantity(false)">
        <Icon size="2xs" name="minus" :color="'black'" />
      </button>
      <div class="flex items-center">{{ quantity }}</div>
      <button class="px-6 py-3" @click="changeQuantity(true)">
        <Icon size="2xs" name="plus" :color="'black'" />
      </button>
    </div>
    <div class="flex flex-wrap gap-3">
      <Button
        class="product__button snipcart-add-item"
        :data-item-id="data.id"
        :data-item-price="data.price"
        :data-item-description="data.description"
        :data-item-image="data.images[0].url"
        :data-item-name="data.title"
        :data-item-quantity="quantity.valueOf().toString()"
        :data-config-modal-style="'side'"
        :data-item-custom1-name="variation ? $t('Variation') : undefined"
        :data-item-custom1-type="variation ? 'readonly' : undefined"
        :data-item-custom1-value="variation ?? undefined"
        :data-item-custom1-required="variation ? true : undefined"
        :data-item-custom2-name="$t('shop.note')"
        data-item-custom2-type="textarea"
        :label="$t('To Cart')"
        :variant="'solid'"
        :icon="{
          name: 'arrow-right',
          size: 'sm',
          color: outOfStock || (variation.length && variation.length) < 1 ? 'gray' : 'white'
        }"
        :disabled="outOfStock || (variation.length && variation.length < 1)"
      />

      <Button v-if="outOfStock" :label="$t('inquiryForm.label')" icon :to="$t('inquiryForm.route')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, PropType } from 'vue'

const changeQuantity = (increase: boolean) => {
  if (increase) {
    quantity.value++
  } else if (!increase && quantity.value > 1) {
    quantity.value--
  } else {
    quantity.value = 1
  }
}

const quantity = ref(1)

defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => ({})
  },
  variation: {
    type: String as PropType<string>,
    default: () => ''
  },
  outOfStock: {
    type: Boolean,
    default: false
  }
})
</script>
